<template>
  <div class="reparatii-auto-container1">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name8"
    ></app-navigation>
    <main class="reparatii-auto-main">
      <div id="transport" class="reparatii-auto-hero section-container">
        <div class="reparatii-auto-max-width1 max-content-container">
          <div class="reparatii-auto-content-container1">
            <h1 class="reparatii-auto-text10">
              <span>
                COMBINATUL AUTO
                <span v-html="rawsmos"></span>
              </span>
              <span class="reparatii-auto-text12">nr.4</span>
              <br />
              <span class="reparatii-auto-text14">s</span>
              <span class="reparatii-auto-text15">
                ervicii de
                <span v-html="raw3hnh"></span>
              </span>
              <br />
              <span class="reparatii-auto-text17">calitate</span>
              <br />
              <span class="reparatii-auto-text18">IN</span>
              <span class="reparatii-auto-text19">
                <span v-html="raw82yx"></span>
              </span>
              <span class="reparatii-auto-text20">Moldova</span>
              <span class="reparatii-auto-text21"></span>
            </h1>
            <span class="reparatii-auto-text22">
              <span>N</span>
              <span class="reparatii-auto-text24">
                oi garantam executarea rapida și la un nivel
                <span v-html="rawjwqm"></span>
              </span>
              <br />
              <span class="reparatii-auto-text26">
                inalt a comenzilor Dvs.
                <span v-html="raw5r59"></span>
              </span>
            </span>
            <div class="reparatii-auto-btns-container1">
              <a
                href="https://combinatulauto.md/#servicii"
                target="_blank"
                rel="noreferrer noopener"
                class="reparatii-auto-primary button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="https://combinatulauto.md/#contacts"
                target="_blank"
                rel="noreferrer noopener"
                class="reparatii-auto-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="reparatii-auto-video-container">
            <div class="reparatii-auto-container2"></div>
          </div>
        </div>
        <div class="reparatii-auto-blue-background"></div>
      </div>
      <div class="reparatii-auto-text-content">
        <h1 class="reparatii-auto-text27">reparatii auto</h1>
        <span class="reparatii-auto-text28">servicii la preturi accesibile</span>
        <span class="reparatii-auto-text29">
          <span class="reparatii-auto-text30">
            Companiile
            <span v-html="raw5yt4"></span>
          </span>
          <span class="reparatii-auto-text31">
            de transport pot beneficia de un complex de servicii de reparatie a
            autocarelor,
            <span v-html="rawfi44"></span>
          </span>
          <br />
          <span class="reparatii-auto-text33">
            camioanelor
            <span v-html="raw7ymp"></span>
          </span>
          <span class="reparatii-auto-text34">
            Avind o echipA de mecanici cu zeci de ani de experienta, precum si
            utilajul necesar,
            <span v-html="raw6hxr"></span>
          </span>
          <br />
          <span class="reparatii-auto-text36">
            la noi puteti beneficia de servicii calitative si la preturi
            avantajoase pentru buna funcționare a camionului, a remorcii și a
            anvelopelor.
          </span>
          <br />
          <span></span>
          <br />
          <span class="reparatii-auto-text38">
            Pe
            <span v-html="raw6co8"></span>
          </span>
          <span class="reparatii-auto-text39">
            tritoriul sunt mai multe ateliere de:
          </span>
          <br />
          <span class="reparatii-auto-text40">-Diagnostica computerizata</span>
          <br />
          <span class="reparatii-auto-text41">
            - verificări sisteme frânare, direcţie şi suspenie
          </span>
          <br />
          <span class="reparatii-auto-text42">
            - diagnosticarea sistemelor ABS-EBS
          </span>
          <br />
          <span class="reparatii-auto-text43">- reparatiea motoarelor</span>
          <br />
          <span class="reparatii-auto-text44">
            - reparatia instalaţiilor de aer şi frânare, axe – punți,
            <span v-html="raw8a03"></span>
          </span>
          <br />
          <span class="reparatii-auto-text45">
            - reparatia cutii de viteze, diferenţiale,
          </span>
          <br />
          <span class="reparatii-auto-text46">
            - reparatia sistemelor electrice,
          </span>
          <br />
          <span class="reparatii-auto-text47">
            - reparatia sistemului de frinare
          </span>
          <br />
          <span class="reparatii-auto-text48">
            - servicii de sudare,
            <span v-html="raws6op"></span>
          </span>
          <br />
          <span class="reparatii-auto-text49">- atelier de vopsire.</span>
          <br />
          <span class="reparatii-auto-text50">
            - service complet de roţi (montare, demontare, echilibrare,
            recanelare, vulcanizare)
          </span>
          <br />
          <span class="reparatii-auto-text51">
            - Service reparatie remorci &amp; semiremorci
          </span>
          <br />
          <span></span>
        </span>
      </div>
      <div class="reparatii-auto-photo-block">
        <div class="reparatii-auto-container3">
          <div class="reparatii-auto-pricing-card1"></div>
          <div class="reparatii-auto-pricing-card2"></div>
          <div class="reparatii-auto-pricing-card3"></div>
        </div>
      </div>
      <div class="reparatii-auto-location">
        <img
          id="news"
          alt="image"
          srcset="/cars-1500w.webp 1200w, /cars-tablet.webp 800w, /cars-mobile.webp 480w"
          sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
          src="/cars-1500w.webp"
          class="reparatii-auto-image"
        />
        <div class="reparatii-auto-content-container2 section-container">
          <div class="reparatii-auto-container4">
            <span class="reparatii-auto-text53">REPARAtIE AUTO</span>
            <span class="reparatii-auto-text54">Calitativ</span>
            <div class="reparatii-auto-container5">
              <span class="reparatii-auto-text55"><span>motoare</span></span>
              <span class="reparatii-auto-text57"><span>caroserii</span></span>
              <span class="reparatii-auto-text59">
                <span>diagnosticare</span>
              </span>
            </div>
            <div class="reparatii-auto-container6">
              <span class="reparatii-auto-text61">
                oferim servicii de reparație auto
              </span>
              <span class="reparatii-auto-text62">
                <span>
                  la toate tipurile de mașini, secția reparații este dotată cu
                  mecanisme care ne permit a efectua reparații auto calitative și
                  anume: motoare, caroserii, sisteme de transmisie, sisteme de
                  control, sisteme hidraulice, acumulatoare, radiatoare, sisteme
                  de încălzire, sisteme de răcire, sisteme de frînare.
                  <span v-html="raw5vh5"></span>
                </span>
                <br />
                <span>
                  Identificăm cele mai complexe defecțiuni prin diagnosticarea
                  computerizată.
                  <span v-html="rawhabf"></span>
                </span>
              </span>
              <div class="reparatii-auto-btns-container2">
                <a
                  href="#contacts"
                  class="reparatii-auto-register button-secondary button button-md"
                >
                  programeaza-te
                </a>
                <a
                  href="#contacts"
                  class="reparatii-auto-learn-more button button-outline button-md-border"
                >
                  adresa
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="reparatii-auto-numbers-banner section-container">
        <div class="reparatii-auto-container7 max-content-container">
          <div class="reparatii-auto-heading-container1">
            <span class="reparatii-auto-text66">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu.
              <span v-html="raw1z4x"></span>
            </span>
            <h1 class="reparatii-auto-text67 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="raw9fam"></span>
              </span>
            </h1>
          </div>
          <div class="reparatii-auto-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="reparatii-auto-previous-events section-container">
        <div class="reparatii-auto-max-width2 max-content-container">
          <div class="reparatii-auto-heading-container2">
            <h1 class="reparatii-auto-text69 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="reparatii-auto-text71">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name8"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'ReparatiiAuto',
  props: {},
  components: {
    AppNavigation,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      rawsmos: ' ',
      raw3hnh: ' ',
      raw82yx: ' ',
      rawjwqm: ' ',
      raw5r59: ' ',
      raw5yt4: ' ',
      rawfi44: ' ',
      raw7ymp: ' ',
      raw6hxr: ' ',
      raw6co8: ' ',
      raw8a03: ' ',
      raws6op: ' ',
      raw5vh5: ' ',
      rawhabf: ' ',
      raw1z4x: ' ',
      raw9fam: ' ',
    }
  },
  metaInfo: {
    title: 'Reparatii-Auto - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Reparatii-Auto - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.reparatii-auto-container1 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.reparatii-auto-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.reparatii-auto-hero {
  position: relative;
  padding-top: 128px;
}
 
.reparatii-auto-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.reparatii-auto-content-container1 {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.reparatii-auto-text10 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.reparatii-auto-text12 {
  text-transform: lowercase;
}
 
.reparatii-auto-text14 {
  color: var(--dl-color-scheme-pink);
}
 
.reparatii-auto-text15 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.reparatii-auto-text17 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.reparatii-auto-text18 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.reparatii-auto-text19 {
  font-style: normal;
  font-weight: 600;
}
 
.reparatii-auto-text20 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.reparatii-auto-text21 {
  font-style: normal;
  font-weight: 600;
}
 
.reparatii-auto-text22 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.reparatii-auto-text24 {
  text-transform: lowercase;
}
 
.reparatii-auto-text26 {
  text-transform: lowercase;
}
 
.reparatii-auto-btns-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.reparatii-auto-primary {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.reparatii-auto-secondary {
  text-decoration: none;
}
 
.reparatii-auto-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.reparatii-auto-container2 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-600h.webp");
  background-position: center;
}
 
.reparatii-auto-container2:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.reparatii-auto-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.reparatii-auto-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-twounits);
  justify-content: space-between;
}
 
.reparatii-auto-text27 {
  font-size: 3rem;
  text-align: center;
}
 
.reparatii-auto-text28 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.reparatii-auto-text29 {
  max-width: var(--dl-size-size-maxwidth);
  margin-top: var(--dl-space-space-threeunits);
  text-align: center;
  margin-bottom: var(--dl-space-space-threeunits);
  text-transform: uppercase;
}
 
.reparatii-auto-text30 {
  text-transform: capitalize;
}
 
.reparatii-auto-text31 {
  text-transform: lowercase;
}
 
.reparatii-auto-text33 {
  text-transform: lowercase;
}
 
.reparatii-auto-text34 {
  text-transform: lowercase;
}
 
.reparatii-auto-text36 {
  text-transform: lowercase;
}
 
.reparatii-auto-text38 {
  font-weight: 700;
  text-transform: capitalize;
}
 
.reparatii-auto-text39 {
  font-weight: 700;
  text-transform: lowercase;
}
 
.reparatii-auto-text40 {
  text-transform: lowercase;
}
 
.reparatii-auto-text41 {
  text-transform: lowercase;
}
 
.reparatii-auto-text42 {
  text-transform: lowercase;
}
 
.reparatii-auto-text43 {
  text-transform: lowercase;
}
 
.reparatii-auto-text44 {
  text-transform: lowercase;
}
 
.reparatii-auto-text45 {
  text-transform: lowercase;
}
 
.reparatii-auto-text46 {
  text-transform: lowercase;
}
 
.reparatii-auto-text47 {
  text-transform: lowercase;
}
 
.reparatii-auto-text48 {
  text-transform: lowercase;
}
 
.reparatii-auto-text49 {
  text-transform: lowercase;
}
 
.reparatii-auto-text50 {
  text-transform: lowercase;
}
 
.reparatii-auto-text51 {
  text-transform: lowercase;
}
 
.reparatii-auto-photo-block {
  width: 100%;
  display: flex;
  background-size: cover;
  justify-content: center;
  background-image: url("/29bg-1500w.webp");
  background-position: center;
}
 
.reparatii-auto-container3 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  background-size: cover;
  justify-content: center;
}
 
.reparatii-auto-pricing-card1 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: 450px;
  min-height: 450px;
  transition: 0.3s;
  align-items: flex-start;
  padding-top: var(--dl-space-space-twounits);
  border-color: rgba(120, 120, 120, 0.4);
  border-style: groove;
  border-width: 2px;
  margin-right: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-twounits);
  border-radius: var(--dl-radius-radius-radius4);
  padding-right: var(--dl-space-space-twounits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-twounits);
  background-size: cover;
  justify-content: space-between;
  background-image: url("/123-1200w.webp");
  background-position: center;
}
 
.reparatii-auto-pricing-card1:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px #1d5890;
}
 
.reparatii-auto-pricing-card2 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-twounits);
  max-width: 450px;
  min-height: 450px;
  transition: 0.3s;
  align-items: flex-start;
  border-color: rgba(120, 120, 120, 0.4);
  border-style: groove;
  border-width: 2px;
  margin-right: var(--dl-space-space-twounits);
  border-radius: var(--dl-radius-radius-radius4);
  flex-direction: column;
  background-size: cover;
  background-image: url("/home-600h.webp");
  background-position: center;
}
 
.reparatii-auto-pricing-card2:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px #1d5890;
}
 
.reparatii-auto-pricing-card3 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: 450px;
  min-height: 450px;
  transition: 0.3s;
  align-items: flex-start;
  padding-top: var(--dl-space-space-twounits);
  border-color: rgba(120, 120, 120, 0.4);
  border-style: groove;
  border-width: 2px;
  padding-left: var(--dl-space-space-twounits);
  border-radius: var(--dl-radius-radius-radius4);
  padding-right: var(--dl-space-space-twounits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-twounits);
  background-size: cover;
  background-image: url("/16-300h-1200w.webp");
  background-position: center;
}
 
.reparatii-auto-pricing-card3:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px #1d5890;
}
 
.reparatii-auto-location {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: row;
}
 
.reparatii-auto-image {
  width: 55%;
  max-height: 950px;
  object-fit: cover;
}
 
.reparatii-auto-content-container2 {
  flex: 1;
  display: flex;
  align-items: stretch;
  padding-top: 100px;
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: row;
  background-color: var(--dl-color-scheme-black);
}
 
.reparatii-auto-container4 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.reparatii-auto-text53 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -100px;
  padding-top: 4px;
  padding-left: 18px;
  margin-bottom: 6px;
  padding-right: 11px;
  padding-bottom: 6px;
  background-color: var(--dl-color-scheme-lightblue);
}
 
.reparatii-auto-text54 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.1;
}
 
.reparatii-auto-container5 {
  display: flex;
  align-items: flex-end;
  margin-bottom: var(--dl-space-space-twounits);
  flex-direction: column;
}
 
.reparatii-auto-text55 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.reparatii-auto-text57 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -36px;
}
 
.reparatii-auto-text59 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.reparatii-auto-container6 {
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 350px;
  align-items: flex-start;
  margin-left: 124px;
  flex-direction: column;
}
 
.reparatii-auto-text61 {
  color: var(--dl-color-scheme-white);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
 
.reparatii-auto-text62 {
  color: var(--dl-color-scheme-white);
  text-align: justify;
  margin-bottom: var(--dl-space-space-twounits);
  text-transform: none;
}
 
.reparatii-auto-btns-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.reparatii-auto-register {
  text-decoration: none;
}
 
.reparatii-auto-learn-more {
  color: var(--dl-color-scheme-white);
  transition: 0.3s;
  border-color: var(--dl-color-scheme-white);
  text-decoration: none;
}
 
.reparatii-auto-learn-more:hover {
  border-color: var(--dl-color-scheme-pink);
}
 
.reparatii-auto-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
}
 
.reparatii-auto-container7 {
  flex-direction: column;
}
 
.reparatii-auto-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.reparatii-auto-text66 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.reparatii-auto-text67 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.reparatii-auto-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.reparatii-auto-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.reparatii-auto-max-width2 {
  flex-direction: column;
}
 
.reparatii-auto-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.reparatii-auto-text69 {
  text-align: center;
}
 
.reparatii-auto-text71 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .reparatii-auto-max-width1 {
    flex-direction: column;
  }
  .reparatii-auto-content-container1 {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .reparatii-auto-container2 {
    width: 583px;
  }
  .reparatii-auto-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .reparatii-auto-text29 {
    max-width: 100%;
  }
  .reparatii-auto-pricing-card1 {
    width: 100%;
    padding: var(--dl-space-space-twounits);
    max-width: 100%;
    align-items: center;
  }
  .reparatii-auto-pricing-card2 {
    width: 100%;
    max-width: 100%;
    align-items: center;
  }
  .reparatii-auto-pricing-card3 {
    width: 100%;
    max-width: 100%;
    align-items: center;
  }
  .reparatii-auto-location {
    flex-direction: column;
  }
  .reparatii-auto-image {
    width: 100%;
  }
  .reparatii-auto-content-container2 {
    padding-top: 0px;
    padding-left: var(--dl-space-space-threeunits);
  }
  .reparatii-auto-container4 {
    margin-top: -100px;
    align-items: center;
  }
  .reparatii-auto-container6 {
    max-width: 100%;
    margin-left: 0px;
  }
  .reparatii-auto-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
 
@media(max-width: 767px) {
  .reparatii-auto-container2 {
    width: 505px;
  }
  .reparatii-auto-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .reparatii-auto-text29 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .reparatii-auto-container3 {
    flex-flow: column;
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .reparatii-auto-pricing-card1 {
    width: 100%;
    max-width: 450px;
    align-items: center;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .reparatii-auto-pricing-card2 {
    width: 100%;
    max-width: 450px;
    align-items: center;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .reparatii-auto-pricing-card3 {
    width: 100%;
    max-width: 450px;
    align-items: center;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .reparatii-auto-image {
    max-height: 100%;
  }
  .reparatii-auto-content-container2 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .reparatii-auto-text53 {
    margin-left: -24px;
  }
  .reparatii-auto-btns-container2 {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }
  .reparatii-auto-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .reparatii-auto-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .reparatii-auto-text10 {
    font-size: 60px;
  }
  .reparatii-auto-container2 {
    width: 424px;
  }
  .reparatii-auto-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .reparatii-auto-container3 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .reparatii-auto-pricing-card3 {
    margin-bottom: 0px;
  }
  .reparatii-auto-text55 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .reparatii-auto-text57 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .reparatii-auto-text59 {
    font-size: 50px;
    margin-left: var(--dl-space-space-oneandhalfunits);
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .reparatii-auto-text62 {
    text-align: justify;
  }
}
</style>
